import React, { useState } from "react";

const PricingDetails = () => {
  const [credit, setCredit] = useState(50000);
  const remainingCredits = 2000;
  const totalCredits = 89000;

  const handleCreditChange = (e) => {
    setCredit(Number(e.target.value));
  };

  const styles = {
    card: {
      backgroundColor: "#fff",
      padding: "20px",
      borderRadius: "10px",
      maxWidth: "800px",
      margin: "20px auto",
      fontFamily: "Montserrat",
      border: "1px solid #ccc",
    },
    headerText: {
      fontSize: "18px",
      fontWeight: "normal", // Making "Credits" normal
      fontFamily: "Montserrat",
      marginBottom: "15px",
    },
    section: {
      marginBottom: "15px",
      fontFamily: "Montserrat",
    },
    label: {
      fontSize: "14px",
      color: "#555",
      display: "block",
      marginBottom: "5px",
      fontFamily: "Montserrat",
    },
    boldText: {
      fontSize: "18px",
      color: "#000",
      fontWeight: "bold", // Keeping ₹ 2000 bold
      fontFamily: "Montserrat",
    },
    input: {
      width: "100%",
      padding: "8px",
      border: "1px solid #ccc",
      borderRadius: "5px",
      fontSize: "14px",
      fontFamily: "Montserrat",
    },
    totalText: {
      fontSize: "14px",
      color: "#333",
      fontWeight: "normal",
      fontFamily: "Montserrat",
    },
  };

  return (
    <div style={styles.card}>
      <h2 style={styles.headerText}>Credits</h2> {/* Now normal weight */}
      <div style={styles.section}>
        <label style={styles.label}>Remaining credits</label>
        <span style={styles.boldText}>₹ {remainingCredits}</span> {/* Still bold */}
      </div>
      <div style={styles.section}>
        <label style={styles.label}>Credit</label>
        <input
          type="number"
          value={credit}
          onChange={handleCreditChange}
          style={styles.input}
        />
      </div>
      <div>
        <span style={styles.totalText}>Total {totalCredits}</span>
      </div>
    </div>
  );
};

export default PricingDetails;
